import type { DraftDocument, EditorialTask, Quiz, StudyTopic } from '@buakei/types';
import {
  DEMO_DRAFTS,
  DEMO_EDITORIAL_TASKS,
  DEMO_QUIZ,
  DEMO_TOPICS,
} from '@/demo/workspace-content';
import { demoResponse } from './demo-runtime';

export const demoContentService = {
  listDrafts: (): Promise<DraftDocument[]> => demoResponse(DEMO_DRAFTS, []),
  listTopics: (): Promise<StudyTopic[]> => demoResponse(DEMO_TOPICS, []),
  getQuiz: (): Promise<Quiz | null> => demoResponse<Quiz | null>(DEMO_QUIZ, null),
  listEditorialTasks: (): Promise<EditorialTask[]> => demoResponse(DEMO_EDITORIAL_TASKS, []),
};
